import React from "react";
import Header from "../common/Header";

const Scheduled = () => {
  return (
    <>
      {" "}
      <div className="bg-light_purple7 rounded-2xl h-[calc(100vh-32px)] overflow-x-hidden w-full mr-4 relative">
        <div className="px-2 xs:px-5 relative overflow-hidden">
          <div className=" overflow-hidden">
            <Header text="Scheduled" />
          </div>
          <div className="pt-2 lg:pt-4">
            <div className=" overflow-y-auto h-[calc(100vh-200px)] md:h-[calc(100vh-140px)] w-full overflow_x_scroll_style">
              <div className=" flex flex-col items-center justify-center h-full bg-white">
                <h2 className="text-black font-bold text-[30px] md:text-[40px] text-center">
                  Coming Soon
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Scheduled;
